var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"main-banner"},[_c('b-col',{staticClass:"d-none d-sm-block"},[_c('slides')],1),_c('b-col',{staticClass:"d-block d-sm-none m-0 p-0"},[_c('slides-mobile')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }